import type { AppState, AppAction } from './types';

export const initialState: AppState = {
    activeEvent: null,
    activeAmenity: null,
    interests: [],
    timeSlot: 'all day',
    activityType: [],
    events: [],
    filteredEvents: [],
    selectedActivityTypes: [],
    selectedInterests: [],
    user: null,
    itinerary: null,
    isRegistrationOpen: 0,
    viewMode: 'events',
    mapExpanded: false,
    splitRatio: 50,
    amenities: [],
    amenityTypes: [],
    selectedAmenityTypes: [],
};

export function appReducer(state: AppState, action: AppAction): AppState {
    switch (action.type) {
        case 'SET_ACTIVE_EVENT':
            return { ...state, activeEvent: action.payload };
        case 'SET_ACTIVE_AMENITY':
            return { ...state, activeAmenity: action.payload };
        case 'SET_INTERESTS':
            return { ...state, interests: action.payload };
        case 'SET_TIMESLOT':
            return { ...state, timeSlot: action.payload };
        case 'SET_ACTIVITY_TYPE':
            return { ...state, activityType: action.payload };
        case 'SET_EVENTS':
            return { ...state, events: action.payload };
        case 'SET_FILTERED_EVENTS':
            return { ...state, filteredEvents: action.payload };
        case 'SET_SELECTED_INTERESTS':
            return { ...state, selectedInterests: action.payload };
        case 'SET_SELECTED_ACTIVITY_TYPES':
            return { ...state, selectedActivityTypes: action.payload };
        case 'SET_USER':
            return { ...state, user: action.payload };
        case 'SET_ITINERARY':
            return { ...state, itinerary: action.payload };
        case 'SET_IS_REGISTRATION_OPEN':
            return { ...state, isRegistrationOpen: action.payload };
        case 'SET_VIEW_MODE':
            return { ...state, viewMode: action.payload };
        case 'SET_MAP_EXPANDED':
            return { ...state, mapExpanded: action.payload };
        case 'SET_SPLIT_RATIO':
            return { ...state, splitRatio: action.payload };
        case 'SET_AMENITY_TYPES':
            return { ...state, amenityTypes: action.payload };
        case 'SET_SELECTED_AMENITY_TYPES':
            return { ...state, selectedAmenityTypes: action.payload };
        case 'SET_AMENITIES':
            return { ...state, amenities: action.payload };
        default:
            return state;
    }
}
